import { render } from "./appSidebar.vue?vue&type=template&id=0179d5f1&scoped=true"
import script from "./appSidebar.vue?vue&type=script&lang=js"
export * from "./appSidebar.vue?vue&type=script&lang=js"

import "./appSidebar.vue?vue&type=style&index=0&id=0179d5f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0179d5f1"]])

export default __exports__